<template>
    <GlassTypeForm :glass_type="glass_type" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import GlassTypeForm from './GlassTypeForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    GlassTypeForm
  },
  data() {
    return {
      glass_type:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.glass_type=await APIRequest.detail('glass-types',this.$route.params.id)
    this.loaded=true
    
  }
}
</script>
